(function (angular, schoolwork12) {
    
    'use strict';

    angular.module(schoolwork12.app.auth.name)
    
    //Authentication Services 
    .factory(schoolwork12.app.auth.services.authentication, 
        ['$http', '$q', 'storage', schoolwork12.app.common.services.eventNotification, 
        function($http, $q, storage, eventNotification){
            var currentUser = null,

            refreshKeycode = function(currentKeycode) {
                var request =  $http({
                    method : 'POST',
                    data:'',
                    url : schoolwork12.app.auth.endpoints.refreshKeycodeEndpoint,
                    headers : {
                        'Content-Type' : 'application/json',
                        'X-API-TOKEN' : currentKeycode
                    }
                });
                return sendRequest(request);
            },
                
           logout = function() {
                //todo call rest logout API to deactivate token and session data on server side
                if (currentUser) {
                    var request =  $http({
                        method : 'POST',
                        data   :'',
                        url : schoolwork12.app.auth.endpoints.logoutEndpoint,
                        headers : {
                            'Content-Type' : 'application/json',
                            'X-API-TOKEN' : currentUser.keycode
                        }
                    });
                    return sendRequest(request);
                }
            },

            isAuthenticated = function() {
                var user = getCurrentUser();
                if (user != undefined) {
                    var kc = user.keycode;
                    if (kc != undefined) {
                        console.info('isAuthenticated: '.concat(kc));
                        return true;
                    }
                 }
                return false;
            },
                
            hasAdministratorRole = function () {
             var roles = currentUser.roles;   
             for (var i=0, length = roles.length; i < length;i++){
                if (roles[i]._roleId == schoolwork12.app.primaryRoles.administrator)
                    return true;
             }
             return false;
           },
           
           hasTeacherRole = function () {
               var roles = currentUser.roles;   
               for (var i=0, length = roles.length; i < length;i++){
                  if (roles[i]._roleId == schoolwork12.app.primaryRoles.teacher)
                      return true;
               }
               return false;
             },
             
	         hasStudentRole = function () {
	             var roles = currentUser.roles;   
	             for (var i=0, length = roles.length; i < length;i++){
	                if (roles[i]._roleId == schoolwork12.app.primaryRoles.student)
	                    return true;
	             }
	             return false;
	           },  
	           
	           hasLCRole = function () {
		             var roles = currentUser.roles;   
		             for (var i=0, length = roles.length; i < length;i++){
		                if (roles[i]._roleId == schoolwork12.app.primaryRoles.learningCoach)
		                    return true;
		             }
		             return false;
		           }, 

          hasProgParticipantMgrRole = function () {
               var roles = currentUser.roles;
               for (var i=0, length = roles.length; i < length;i++){
                      if (roles[i]._roleId == schoolwork12.app.primaryRoles.progParticipantMgr)
                          return true;
                   }
                   return false;
           }, 
                
           hasEnrollmentAdvisorRole = function () {
             var roles = currentUser.roles;   
             for (var i=0, length = roles.length; i < length;i++){
                if (roles[i]._roleId == schoolwork12.app.primaryRoles.enrollmentAdvisor)
                    return true;
             }
             return false;
           },
           
           hasDataManagementRole = function () {
               var roles = currentUser.roles;   
               for (var i=0, length = roles.length; i < length;i++){
                  if (roles[i]._roleId == schoolwork12.app.primaryRoles.dataManagement)
                      return true;
               }
               return false;
             },
           
           hasComputerRuleManagerRole = function () {
        	   var roles = currentUser.roles;
        	   for (var i=0, length = roles.length; i < length;i++){
                   if (roles[i]._roleId == schoolwork12.app.primaryRoles.computerRuleManager)
                       return true;
                }
                return false;
           },

           hasGradPlanManagerRole = function () {
             var roles = currentUser.roles;
             for (var i=0, length = roles.length; i < length;i++){
                   if (roles[i]._roleId == schoolwork12.app.primaryRoles.gradPlanManager)
                       return true;
                }
                return false;
           },
            
           hasStudentGradPlanViewRole = function () {
             var roles = currentUser.roles;
             for (var i=0, length = roles.length; i < length;i++){
                   if (roles[i]._roleId == schoolwork12.app.primaryRoles.studentGradPlanView)
                       return true;
                }
                return false;
           },
           

           hasStudentGradPlanEditRole = function () {
             var roles = currentUser.roles;
             for (var i=0, length = roles.length; i < length;i++){
                   if (roles[i]._roleId == schoolwork12.app.primaryRoles.studentGradPlanEdit)
                       return true;
                }
                return false;
           },
           
           hasAttendanceAdjusterRole = function () {
               var roles = currentUser.roles;
               for (var i=0, length = roles.length; i < length;i++){
                     if (roles[i]._roleId == schoolwork12.app.primaryRoles.attendanceAdjuster)
                         return true;
                  }
                  return false;
             },
            
           hasCounselorStaffRole = function () {
             var staffRoleId = currentUser.staffRoleId;
             if(staffRoleId != null){
                if(staffRoleId == schoolwork12.app.staffRoles.counselor)
                  return true;
             }
             return false;
           },
           hasSchoolDataManagementRole = function () {
            var roles = currentUser.roles;
            for (var i=0, length = roles.length; i < length;i++){
                   if (roles[i]._roleId == schoolwork12.app.primaryRoles.managementSchoolData)
                       return true;
                }
                return false;
           },
           hasBulkAttendanceAdjusterRole = function () {
               var roles = currentUser.roles;
               for (var i=0, length = roles.length; i < length;i++){
                      if (roles[i]._roleId == schoolwork12.app.primaryRoles.bulkAttendanceAdjuster)
                          return true;
                   }
                   return false;
           },
           hasBulkEditAdditionRequirementRole = function () {
               var roles = currentUser.roles;
               for (var i=0, length = roles.length; i < length;i++){
                      if (roles[i]._roleId == schoolwork12.app.primaryRoles.bulkEditAdditionalReq)
                          return true;
                   }
                   return false;
           },
           hasBulkGradPlanImportRole = function () {
               var roles = currentUser.roles;
               for (var i=0, length = roles.length; i < length;i++){
                      if (roles[i]._roleId == schoolwork12.app.primaryRoles.bulkGradPlanImport)
                          return true;
                   }
                   return false;
           },
           hasBulkImportRole = function () {
        	   // Add new roles here when added
        	   if(hasBulkAttendanceAdjusterRole() || hasBulkEditAdditionRequirementRole() || hasBulkGradPlanImportRole() || hasbulkSchoolDataRole() || hasbulkStudentCreateRole()){
        		   return true;
        	   }
        	   return false;
           },
           hasTvAdministrationToolsRole = function () {
            var roles = currentUser.roles;
            for (var i=0, length = roles.length; i < length;i++){
                  if (roles[i]._roleId == schoolwork12.app.primaryRoles.tvAdministrationTools)
                    return true;
                }
              return false;
           },
           hasCourseManagementRole = function () {
            var roles = currentUser.roles;
            for (var i=0, length = roles.length; i < length;i++){
                  if (roles[i]._roleId == schoolwork12.app.primaryRoles.courseManagement)
                    return true;
                }
              return false;
           },
           hasbulkSchoolDataRole = function () {
            var roles = currentUser.roles;
            for (var i=0, length = roles.length; i < length;i++){
                  if (roles[i]._roleId == schoolwork12.app.primaryRoles.bulkSchoolDataRole)
                    return true;
                }
              return false;
           },
           hasbulkStudentCreateRole = function () {
            var roles = currentUser.roles;
            for (var i=0, length = roles.length; i < length;i++){
                  if (roles[i]._roleId == schoolwork12.app.primaryRoles.bulkStudentCreationRole)
                    return true;
                }
              return false;
           },
           haspathwayRequirementsRole = function () {
            var roles = currentUser.roles;
            for (var i=0, length = roles.length; i < length;i++){
                  if (roles[i]._roleId == schoolwork12.app.primaryRoles.pathwayRequirements)
                    return true;
                }
              return false;
           },
           hasPathwayRequirementEditRole = function(){
            var roles = currentUser.roles;
            for (var i=0, length = roles.length; i < length;i++){
                  if (roles[i]._roleId == schoolwork12.app.primaryRoles.pathwayRequirementEditRole)
                    return true;
                }
              return false;
           },
           getSchools = function() {
               return currentUser.schools;
           },

           isSchoolActive = function() {
             var schools = currentUser.schools;
             if (schools.length > 0) {
                 return true;
             } 
             return false;
           },

           isCRETrackingOn = function() {
            var schools = currentUser.schools;
            var results = schools.filter(function (obj) { 
              return obj.isCRETrackingOn === true; 
            });
      
            console.log("check")

            if(results.length > 0) {
                return true;
            } else {
              return false;
            }
          },
        
           isGradPlanOn = function() {
             var schools = currentUser.schools;
              if(hasGradPlanManagerRole() || hasStudentGradPlanEditRole()){
                var results = schools.filter(function (obj) { 
                  return obj.isGradPlanOn === true; 
                });
          
                if(results.length > 0) {
                    return true;
                } 
              }
              return false;
           },
           
           showTVEInQuickLinks = function(){
        	   if(hasTeacherRole()){
              if(isEnrollmentOn()){
                return true;
                }
              else {
                return false;
                }
              }
              return true;
            },
            
            showPFInQuickLinks = function(){
         	   if(hasComputerRuleManagerRole()){
                 return true;
         	   }
               else {
                 return false;
                 }
              },

           isEnrollmentOn = function() {
               var schools = currentUser.schools;
                 var results = schools.filter(function (obj) { 
                    return obj.isEnrollmentOn === true; 
                  });
            
                  if(results.length > 0) {
                      return true;
                  } 
                return false;
             },
             
           getPrimaryRole = function() {
             var roles = currentUser.roles;  
             //var rolesSet = new Set(schoolwork12.app.primaryRolesArray);
             for (var i=0, length = roles.length; i < length;i++){
                 for(var j=0;j<schoolwork12.app.primaryRolesArray.length;j++)
                     {
                        if (schoolwork12.app.primaryRolesArray[j] == roles[i]._roleId){
                            return roles[i]._name;                 
                        }
                     }
             }
             return "N/A";
           },

           getRolesDisplayString = function() {
             var roleStr = " ";
             var r;
             var roles = currentUser.roles;   
             for (var i=0, length = roles.length; i < length;i++){
                 roleStr = roleStr.concat(roles[i]._name).concat(', ');
             }
             return roleStr;
           },
                
           clear= function() {
               currentUser = null;
           },
       
           getCurrentUser = function() {
                return currentUser;
            },
                
            setCurrentUser = function(authenticatedUser) {
                currentUser = authenticatedUser;
            },
                
           keycodeAuthenticate = function(keycode) {
               
               console.info('passed in keycode is :'.concat(keycode));
               console.info('Calling keycodeLogin API');
               
                var deferred = $q.defer();
              var request =  $http({
                method : 'POST',
                url : schoolwork12.app.auth.endpoints.keycodeLoginEndpoint,
                data:'',
                headers : {
                    'Content-Type' : 'application/json',
                    'X-API-TOKEN' : keycode
                }
                });
                request.then(function(response) {
                    var authToken = response.data._keycode;
                    console.info('keycodeLogin : authToken:'.concat(authToken));
                    $http.defaults.headers.common['Authorization'] = authToken;
                    
                       currentUser = {
                           username : response.data._username,
                           keycode : response.data._keycode,
                           roles : response.data._userRoles,
                           schools: response.data._schools,
                           identityid : response.data._identityId,
                           accountid : response.data._accountId,
                           staffRoleId : response.data._staffRoleId,
                           studentId : response.data._studentId,
                           schoolId : response.data._schoolId,
                           personId : response.data._personId
                       }
                 
                       deferred.resolve(currentUser);
                    eventNotification.broadcast(schoolwork12.app.auth.events.userLoggedIn, currentUser);
                   }, function(error){
                        console.error('Error in keycodeLogin....'.concat(angular.toJson(error)));
                        deferred.reject(error);
                   });
                return deferred.promise;
           },
                
           authenticate = function (username, password) {

               var deferred = $q.defer();
               var data = 'username='.concat(username).concat('&password=').concat(password);

               var request = $http({
                  method: 'POST',
                  url: schoolwork12.app.auth.endpoints.authenticationEndpoint,
                  data: data,
                  headers: {
                    'Accept': '*/*',
                    'Content-Type': 'application/x-www-form-urlencoded'
                  }
                });

                request.then(function(response){
                  var authToken = response.data._keycode;
                    console.info('authToken='.concat(authToken));
                    $http.defaults.headers.common['Authorization'] = authToken;
                       currentUser = {
                           username : response.data._username,
                           keycode : response.data._keycode,
                           roles : response.data._userRoles,
                           schools: response.data._schools,
                           identityid : response.data._identityId,
                           accountid : response.data._accountId,
                           staffRoleId : response.data._staffRoleId,
                           personId : response.data._personId
                       }
                 
                    deferred.resolve(currentUser);
                    eventNotification.broadcast(schoolwork12.app.auth.events.userLoggedIn, currentUser);
                    
                }, function(error){
                  deferred.reject(error);
                });

                return deferred.promise;
              },

           sendRequest = function(config){

                var deferred = $q.defer();

                config.then(function(response){
                  deferred.resolve(response);
                }, function(error){
                  deferred.reject(error);
                });

                return deferred.promise;
             };
            
          return {
              authenticate: authenticate,
              keycodeAuthenticate: keycodeAuthenticate,
              refreshKeycode: refreshKeycode,
              clear: clear,
              logout: logout,
              isAuthenticated: isAuthenticated,
              getCurrentUser: getCurrentUser,
              setCurrentUser: setCurrentUser,
              getRolesDisplayString: getRolesDisplayString,
              getPrimaryRole: getPrimaryRole,
              getSchools: getSchools,
              isSchoolActive: isSchoolActive,
              isGradPlanOn: isGradPlanOn,
              isCRETrackingOn: isCRETrackingOn,
              isEnrollmentOn:isEnrollmentOn,
              hasEnrollmentAdvisorRole: hasEnrollmentAdvisorRole,
              hasAdministratorRole: hasAdministratorRole,
              hasTeacherRole: hasTeacherRole,
              hasStudentRole: hasStudentRole,
              hasComputerRuleManagerRole: hasComputerRuleManagerRole,
              hasGradPlanManagerRole: hasGradPlanManagerRole,
              hasStudentGradPlanViewRole: hasStudentGradPlanViewRole,
              hasStudentGradPlanEditRole: hasStudentGradPlanEditRole,
              hasCounselorStaffRole: hasCounselorStaffRole,
              hasStudentGradPlanEditRole: hasStudentGradPlanEditRole,
              hasSchoolDataManagementRole: hasSchoolDataManagementRole,
              hasAttendanceAdjusterRole: hasAttendanceAdjusterRole,
              hasBulkImportRole: hasBulkImportRole,
              hasBulkAttendanceAdjusterRole: hasBulkAttendanceAdjusterRole,
              hasBulkEditAdditionRequirementRole: hasBulkEditAdditionRequirementRole,
              hasBulkGradPlanImportRole: hasBulkGradPlanImportRole,
              showTVEInQuickLinks: showTVEInQuickLinks,
              showPFInQuickLinks: showPFInQuickLinks,
              hasLCRole: hasLCRole,
              hasProgParticipantMgrRole: hasProgParticipantMgrRole,
              hasDataManagementRole: hasDataManagementRole,
              hasTvAdministrationToolsRole: hasTvAdministrationToolsRole,
              hasCourseManagementRole: hasCourseManagementRole,
              hasbulkSchoolDataRole: hasbulkSchoolDataRole,
              hasbulkStudentCreateRole: hasbulkStudentCreateRole,
              haspathwayRequirementsRole: haspathwayRequirementsRole,
              hasPathwayRequirementEditRole: hasPathwayRequirementEditRole
              };

    }]);
    
}(angular, schoolwork12));
